import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { HomeService } from '../../services/home.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {

  constructor(public bsModalRef: BsModalRef,
    public service: HomeService,
    public router: Router) { }

  ngOnInit(): void {
  }
  onClose: any;
  goods: string;
  goodsList: any = [];
  selectedGoods: any = [];
  goodsData: any = [];
  cancel() {
    this.onClose('cancel');
    this.bsModalRef.hide();
  }

  confirm() {
    this.bsModalRef.hide();
    this.onClose('confirm');
  }

}
